import { ChangeEvent, FC, MouseEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import "./EditForm.css";
import { editUser, getUserById } from "../../../redux/requests/UserRequests";
import Loader from "../../UI/loader/Loader";

interface IUserEditProps {}

const UserEdit: FC<IUserEditProps> = () => {
  const params = useParams();
  const user = useAppSelector(
    (state) =>
      state.users.users.find((item) => item.id === params.id) ||
      state.users.selectedUser
  );

  const dispatch = useAppDispatch();

  const [name, setName] = useState<string>(user?.name || "");
  const [phone, setPhone] = useState<string>(user?.phone || "");
  const [telegramId, setTelegramId] = useState<string>(user?.telegramId || "");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!user && params.id) {
      dispatch(getUserById(params.id));
    }
  }, [params.id, user, dispatch]);

  useEffect(() => {
    if (user) {
      setName(user.name);
      setPhone(user.phone);
    }
  }, [user]);

  if (!user) return <Loader />;

  const onPhoneInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPhone(event.target.value);
  };

  const onNameInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const onTelegramIdInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTelegramId(event.target.value);
  };

  const onSaveClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    let data = {};
    if (phone.trim() && phone.trim() !== user?.phone)
      data = {
        phone: phone.trim(),
        ...data,
      };

    if (name.trim() && name.trim() !== user?.name)
      data = {
        name: name.trim(),
        ...data,
      };

    if (telegramId.trim() && telegramId.trim() !== user?.telegramId)
      data = {
        telegramId: telegramId.trim(),
        ...data,
      };

    if (Object.keys(data).length !== 0) {
      if (user)
        dispatch(editUser(user?.id, data)).then((data) => {
          if (data) {
            navigate("/admin");
          } else {
            setError("Ошибка! Повторите снова!");
          }
        });
    } else {
      setError("Нет никаких изменений!");
    }
  };

  return (
    <div className="edit">
      <div className="edit-container">
        <h1>Клиент {user?.name}</h1>
        <div className="edit-inputs">
          <input
            type="text"
            placeholder="Имя"
            value={name}
            required
            onChange={onNameInputChange}
          />

          <input
            type="tel"
            placeholder="Телефон"
            value={phone}
            required
            onChange={onPhoneInputChange}
          />

          <input type="id" 
          placeholder="TelegramId"
          value={telegramId}
          required
          onChange={onTelegramIdInputChange}
          />
        </div>
        <div className="edit-buttons">
          <button className="edit-btn" onClick={onSaveClick}>
            Сохранить изменения
          </button>
        </div>
        <p className="error-label">{error}</p>
      </div>
    </div>
  );
};

export default UserEdit;
